<template>
  <c-row>
    <c-col col="6">
      <c-card>
        <loading v-show="loading" />
        <c-card-header>
          <c-card-title>
            <strong>Asset</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Kode</label>
            <div class="col-sm-9">
              <select-x
                url="/api/v1/asset-code?detail=true"
                placeholder="Asset Code"
                label="name"
                v-model="asset.code"
                v-bind:class="{ 'has-error': errors.asset_code_id }"
                :size="10"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Nama</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-bind:class="{ 'has-error': errors.name }"
                v-model="asset.name"
                placeholder="Nama"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Tanggal</label>
            <div class="col-sm-9">
              <datetime
                class="date-control"
                format="dd MMMM yyyy"
                type="text"
                v-bind:class="{ 'has-error': errors.date }"
                v-model="asset.date"
                placeholder="Tanggal"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Qty</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control right"
                v-bind:class="{ 'has-error': errors.qty }"
                v-model="asset.qty"
                placeholder="Jumlah"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Harga</label>
            <div class="col-sm-9">
              <button-edit-input-2
                v-model="asset.price"
                v-bind:class="{ 'has-error': errors.price }"
                :rounded="true"
                :bordered="true"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Durasi</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control right"
                v-bind:class="{ 'has-error': errors.duration }"
                v-model="asset.duration"
                placeholder="Durasi"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Beban (%)</label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control right"
                v-bind:class="{ 'has-error': errors.expense }"
                v-model="asset.expense"
                placeholder="Beban"
              />
            </div>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-success" @click="save">
            <i class="cil-save"></i> Simpan
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
    <asset-code />
  </c-row>
</template>
<script>
import AssetCode from "../asset/AssetCode";
import SelectX from "../../components/SelectX";
import ButtonEditInput2 from "../../components/ButtonEditInput2";
import { HTTPAUTH } from "../../lib/httplib";
import Loading from "../../components/Loading";
export default {
  data () {
    return {
      asset: {},
      errors: [],
      loading: false
    };
  },
  components: { AssetCode, SelectX, ButtonEditInput2, Loading },
  created () {
    this.init();
  },
  methods: {
    save () {
      this.loading = true;
      this.asset.asset_code_id = (this.asset.code ? this.asset.code.id : 0);
      HTTPAUTH.post("/api/v1/asset", this.asset)
        .then(() => {
          this.loading = false;
          this.asset = {};
          this.errors = [];
          this.$toasted.success("Berhasil ditambahkan").goAway();
          this.init();
        })
        .catch(eres => {
          this.loading = false;
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(3000);
            this.errors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
    },
    updateValue (i, v) {
      this.asset.price = v;
    },
    init () {
      this.asset = {
        date: moment().format(),
      }
    }
  }
};
</script>